// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"126":"7081a197","768":"4bb911e2"}[chunkId] + ".chunk.css";
};